/* Package JSON Import will be here */
import { filter, forEach } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import {
  orderHistoryApi,
  orderHistoryDetailsApi,
  getOrderInvoiceListApi,
  cancelOrderListApi,
  cancelOrderApi,
  orderUploadApi
} from "services/orders";
import { normalize, getErrorObject, mergeMultipleSchemeOrderSummary, errorToast } from "utilities/utils";
import { IOrderHistoryDetailsAction, IOrderInvoiceParams } from "models/orderModels";
import { navigateToOrderHistoryList } from "app/navigation";
import { showMsgFromJson } from "reducers/common";
import { getCartDetails } from "reducers/cart";
import Constants from "utilities/appConstants";
import { IOrderHistoryFilterParams, IOrderUploadParams } from "models/orderModels";
import { GACancelOrder } from "hooks/googleAnalyticsHooks";
import { GAAddToCart } from "hooks/googleAnalyticsHooks";
/* Project Import will be here */

export const types = {
  ORDER_HISTORY_REQUEST: "orderHistory/ORDER_HISTORY_REQUEST",
  ORDER_HISTORY_SUCCESS: "orderHistory/ORDER_HISTORY_SUCCESS",
  ORDER_HISTORY_FAILURE: "orderHistory/ORDER_HISTORY_FAILURE",

  CANCEL_ORDER_LIST_REQUEST: "orderHistory/CANCEL_ORDER_LIST_REQUEST",
  CANCEL_ORDER_LIST_SUCCESS: "orderHistory/CANCEL_ORDER_LIST_SUCCESS",
  CANCEL_ORDER_LIST_FAILURE: "orderHistory/CANCEL_ORDER_LIST_FAILURE",

  CANCEL_ORDER_SUBMIT_REQUEST: "orderHistory/CANCEL_ORDER_SUBMIT_REQUEST",
  CANCEL_ORDER_SUBMIT_SUCCESS: "orderHistory/CANCEL_ORDER_SUBMIT_SUCCESS",
  CANCEL_ORDER_SUBMIT_FAILURE: "orderHistory/CANCEL_ORDER_SUBMIT_FAILURE",

  ORDER_HISTORY_DETAIL_REQUEST: "orderHistory/ORDER_HISTORY_DETAIL_REQUEST",
  ORDER_HISTORY_DETAIL_SUCCESS: "orderHistory/ORDER_HISTORY_DETAIL_SUCCESS",
  ORDER_HISTORY_DETAIL_FAILURE: "orderHistory/ORDER_HISTORY_DETAIL_FAILURE",

  REPEAT_ORDER_DETAIL_REQUEST: "orderHistory/REPEAT_ORDER_DETAIL_REQUEST",
  REPEAT_ORDER_DETAIL_SUCCESS: "orderHistory/REPEAT_ORDER_DETAIL_SUCCESS",
  REPEAT_ORDER_DETAIL_FAILURE: "orderHistory/REPEAT_ORDER_DETAIL_FAILURE",

  ORDER_INVOICE_REQUEST: "orderHistory/ORDER_INVOICE_REQUEST",
  ORDER_INVOICE_SUCCESS: "orderHistory/ORDER_INVOICE_SUCCESS",
  ORDER_INVOICE_FAILURE: "orderHistory/ORDER_INVOICE_FAILURE",

  CLEAR_ORDER_HISTORY_DETAIL: "orderHistory/CLEAR_ORDER_HISTORY_DETAIL",
};

const initialState = {
  list: {
    ids: [],
    data: {},
    totalCount: 0,
    responseCount: 0,
    responseTotalCount: 0,
    count: 0,
    isLoading: false,
    error: null
  },
  cancelOrderList: {
    ids: [],
    data: {},
    totalCount: 0,
    responseCount: 0,
    responseTotalCount: 0,
    count: 0,
    isLoading: false,
    error: null
  },
  cancelOrderSubmit: {
    isLoading: false,
    orderNo: "",
    error: null
  },
  details: {
    orderId: null,
    ids: [],
    data: {},
    orderSummary: {},
    freeProducts: [],
    isLoading: false,
    isRepeatOrderLoading: false,
    error: null
  },
  invoiceList: {
    data: [],
    isLoading: false,
    error: null
  }
};

export const orderHistory = (state = initialState, action) => {
  switch (action.type) {
    case types.ORDER_HISTORY_REQUEST: {
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: true
        }
      };
    }
    case types.ORDER_HISTORY_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          error: null,
          ...action.payload
        }
      };
    }
    case types.ORDER_HISTORY_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        list: {
          ...state.list,
          ids: [],
          data: {},
          totalCount: 0,
          isLoading: false,
          error
        }
      };
    }
    case types.CANCEL_ORDER_LIST_REQUEST: {
      return {
        ...state,
        cancelOrderList: {
          ...state.cancelOrderList,
          isLoading: true
        }
      };
    }
    case types.CANCEL_ORDER_LIST_SUCCESS: {
      return {
        ...state,
        cancelOrderList: {
          ...state.cancelOrderList,
          isLoading: false,
          error: null,
          ...action.payload
        }
      };
    }
    case types.CANCEL_ORDER_LIST_FAILURE: {
      return {
        ...state,
        cancelOrderList: {
          ...state.cancelOrderList,
          ids: [],
          data: {},
          totalCount: 0,
          isLoading: false,
          ...action.payload
        }
      };
    }
    case types.CANCEL_ORDER_SUBMIT_REQUEST: {
      return {
        ...state,
        cancelOrderSubmit: {
          isLoading: true,
          ...action.payload,
        }
      };
    }
    case types.CANCEL_ORDER_SUBMIT_SUCCESS: {
      return {
        ...state,
        cancelOrderSubmit: {
          isLoading: false,
          orderNo: "",
        }
      };
    }
    case types.CANCEL_ORDER_SUBMIT_FAILURE: {
      return {
        ...state,
        cancelOrderSubmit: {
          isLoading: false,
          orderNo: "",
          ...action.payload,
        }
      };
    }
    case types.ORDER_HISTORY_DETAIL_REQUEST: {
      const { orderId } = action.payload;
      return {
        ...state,
        details: {
          ...state.details,
          isLoading: true,
          orderId
        }
      };
    }
    case types.ORDER_HISTORY_DETAIL_SUCCESS: {
      const { ids, data, orderSummary, freeProducts } = action.payload;
      return {
        ...state,
        details: {
          ...state.details,
          orderSummary,
          freeProducts,
          isLoading: false,
          error: null,
          ids,
          data
        }
      };
    }
    case types.ORDER_HISTORY_DETAIL_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        details: {
          ...state.details,
          isLoading: false,
          error
        }
      };
    }
    case types.ORDER_INVOICE_REQUEST: {
      return {
        ...state,
        invoiceList: {
          ...state.invoiceList,
          isLoading: true
        }
      };
    }
    case types.ORDER_INVOICE_SUCCESS: {
      return {
        ...state,
        invoiceList: {
          ...state.invoiceList,
          isLoading: false,
          error: null,
          data: action.payload.data
        }
      };
    }
    case types.ORDER_INVOICE_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        invoiceList: {
          ...state.invoiceList,
          isLoading: false,
          data: [],
          error
        }
      };
    }
    case types.CLEAR_ORDER_HISTORY_DETAIL: {
      return {
        ...state,
        details: {
          ...state.details,
          orderId: null,
          ids: [],
          data: {}
        }
      };
    }

    case types.REPEAT_ORDER_DETAIL_REQUEST:
      return {
        ...state,
        details: {
          ...state.details,
          isRepeatOrderLoading: true,
        }
      };

    case types.REPEAT_ORDER_DETAIL_SUCCESS:
    case types.REPEAT_ORDER_DETAIL_FAILURE:
      return {
        ...state,
        details: {
          ...state.details,
          isRepeatOrderLoading: false,
        }
      };

    default:
      return state;
  }
};

export const getOrderHistory = () => {
  return async (dispatch, getState) => {
    dispatch({ type: types.ORDER_HISTORY_REQUEST });
    try {
      /* Fetch the order history from the server */
      const hFilter = getState().historyFilter;
      const requestObj = getHistoryFilterReq(hFilter);

      const response = await orderHistoryApi(requestObj);

      const { data, ids } = normalize({ data: response.data.Data, key: "OrderNo" });

      dispatch({
        type: types.ORDER_HISTORY_SUCCESS,
        payload: {
          data: data,
          ids: ids,
          totalCount: hFilter.isFilterApplied ? getState().orderHistory.list.totalCount : ids.length,
          responseCount: response.data.Count,
          responseTotalCount: response.data.TotalCount
        }
      });
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.ORDER_HISTORY_FAILURE));
    }
  };
};

export const getCancelOrderList = () => {
  return async (dispatch, getState) => {
    dispatch({ type: types.CANCEL_ORDER_LIST_REQUEST });
    try {
      /* Fetch the order history from the server */
      const hFilter = getState().historyFilter;
      const requestObj = getHistoryFilterReq(hFilter);

      const response = await cancelOrderListApi(requestObj);

      const { data, ids } = normalize({ data: response.data.Data, key: "OrderNo" });

      dispatch({
        type: types.CANCEL_ORDER_LIST_SUCCESS,
        payload: {
          data: data,
          ids: ids,
          totalCount: hFilter.isFilterApplied ? getState().orderHistory.list.totalCount : ids.length,
          responseCount: response.data.Count,
          responseTotalCount: response.data.TotalCount
        }
      });
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.CANCEL_ORDER_LIST_FAILURE));
    }
  };
};

/* Cancel the specific selected order */
export const cancelOrder = (orderNumber) => {
  return async (dispatch, getState) => {
    dispatch({
      type: types.CANCEL_ORDER_SUBMIT_REQUEST,
      payload: { orderNo: orderNumber }
    });

    try {
      const reqObj = { OrderNo: orderNumber };
      await cancelOrderApi(reqObj);

      dispatch({ type: types.CANCEL_ORDER_SUBMIT_SUCCESS });

      /* Cancel order success toast */
      dispatch(showMsgFromJson("common.alerts.success.orderCancelSuccess", Constants.SUCCESS));

      /* reload the data */
      dispatch(getCancelOrderList());

      /* GA - Track cancel order event */
      if (window.isEnableGA)
        GACancelOrder(orderNumber);
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.CANCEL_ORDER_SUBMIT_FAILURE));
      dispatch(showMsgFromJson("common.alerts.error.cancelOrderFailure", Constants.ERROR));
    }
  };
};

const getHistoryFilterReq = (hFilter) => {
  const requestObj: IOrderHistoryFilterParams = {
    SearchText: hFilter.searchText,
    FromDate: hFilter.month !== null ? hFilter.monthStartDate : hFilter.startDate,
    ToDate: hFilter.month !== null ? hFilter.monthEndDate : hFilter.endDate
  };

  return requestObj;
}

export const getOrderHistoryDetails = (data: IOrderHistoryDetailsAction) => {
  return async (dispatch, getState) => {
    const config = getState().appSettings;

    dispatch({
      type: types.ORDER_HISTORY_DETAIL_REQUEST,
      payload: { orderId: data.orderId }
    });

    try {
      /* Fetch the order history details from the server */
      const response = await orderHistoryDetailsApi({
        OrderId: data.orderId,
        NeedSummary: true
      });

      /* Merge multiple schemed products - Only non free products */
      const nonFreeProducts = filter(response.data.Data, (o) => { return !o.IsFree; });

      /* Merge same product with multiple scheme */
      let dataArr = mergeMultipleSchemeOrderSummary(nonFreeProducts);

      /* Convert case and piece count from QTY */
      dataArr = convertCaseAndPieceQty(dataArr, config, false);

      const normalizedOrderHistory = normalize({
        data: dataArr,
        key: "ProductId"
      });

      /* Separate free products from the response if any - Assign feee products */
      const freeProducts = filter(response.data.Data, (o) => { return o.IsFree; });

      dispatch({
        type: types.ORDER_HISTORY_DETAIL_SUCCESS,
        payload: {
          ...normalizedOrderHistory,
          orderSummary: response.data.OrderSummary[0],
          freeProducts: convertCaseAndPieceQty(freeProducts, config, true)
        }
      });
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.ORDER_HISTORY_DETAIL_FAILURE));
      dispatch(showMsgFromJson("reports.orderHistory.invalidOrderNumber", Constants.ERROR));
      dispatch(navigateToOrderHistoryList());
    }
  };
};

/* Repeat order - Add order history details products into cart */
export const repeatOrderDetails = (products) => {
  return async (dispatch, getState) => {
    dispatch({ type: types.REPEAT_ORDER_DETAIL_REQUEST });
    try {
      const appSettings = getState().appSettings;

      let requestObject: IOrderUploadParams = [];
      forEach(products, (item) => {
        let totalQty = item.Qty;
        /* Check for min order qty */
        if (appSettings.isEnableMinOrderQty && item.MinORDQty !== 0) {
          if (totalQty >= item.MinORDQty && (totalQty <= item.MaxORDQty || item.MaxORDQty === 0))
            totalQty = (Math.ceil(totalQty / item.MinORDQty) * item.MinORDQty);
          else
            totalQty = item.MinORDQty;
        }

        requestObject.push({
          PId: item.ProductId,
          Qty: totalQty,
          Price: item.Price,
          PName: item.ProductName,
          DiscountId: 0,
          SchemeId: item.SchemeId,
          PrincipalId: item.PrincipalId,
          ImageUrl: item.ImageUrl,
          DistributorId: item.DistributorId,
          UomId: item.UomId,
          UomCount: item.UomCount,
          GroupId: item.GroupId,
          GroupName: item.GroupName
        });
      });

      await orderUploadApi(requestObject);

      /* Fetch updated cart information */
      await dispatch(getCartDetails());

      dispatch({ type: types.REPEAT_ORDER_DETAIL_SUCCESS });

      /* Order upload success toast */
      dispatch(showMsgFromJson("common.alerts.success.orderUpload", Constants.SUCCESS));

      /* To track GA add to cart order products list  */
      if (window.isEnableGA)
        GAAddToCart(requestObject);
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.REPEAT_ORDER_DETAIL_FAILURE, true));

       /* Fetch updated cart information */
       await dispatch(getCartDetails());
    }
  };
};

/* Convert the QTY into case and piece QTY */
const convertCaseAndPieceQty = (productList, config, isFromFreeProduct) => {
  /* Change the case piece QTY values */
  forEach(productList, (o) => {
    if (config.isEnablePlaceOrderCase) {
      /* Check for free product QTY */
      if (isFromFreeProduct) {
        /* Case - Enable, Piece - Disable, ConversionQTY - 0 (Assign all qty to case) */
        if (!config.isEnablePlaceOrderPiece && o.ConversionQty === 0) {
          o.caseQTY = o.Qty;
          o.pieceQTY = 0;
        }
        /* Case - Enable, Piece - Disable, ConversionQTY > 0 (assign divided qty to case) */
        else if (!config.isEnablePlaceOrderPiece && o.ConversionQty > 0) {
          o.caseQTY = ~~(o.Qty / o.ConversionQty) + (((o.Qty / o.ConversionQty) % 1) > 0 ? 1 : 0);
          o.pieceQTY = 0;
        }
        /* Case - Enable, Piece - Enable, ConversionQTY - Any thing (Assign all qty to piece) */
        else if (config.isEnablePlaceOrderPiece) {
          o.caseQTY = 0;
          o.pieceQTY = o.Qty
        }
      }
      else {
        o.caseQTY = ~~(o.Qty / o.ConversionQty);
        o.pieceQTY = (o.Qty % o.ConversionQty);
      }
    }
    else {
      o.caseQTY = 0;
      o.pieceQTY = o.Qty
    }
  });

  return productList;
}


export const getOrderInvoiceList = (orderNo: String) => {
  return async dispatch => {
    dispatch({ type: types.ORDER_INVOICE_REQUEST });
    try {
      const data: IOrderInvoiceParams = {
        OrderNo: orderNo
      };

      /* Fetch the order history from the server */
      const response = await getOrderInvoiceListApi(data);

      dispatch({ type: types.ORDER_INVOICE_SUCCESS, payload: { data: response.data.Data } });
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.ORDER_INVOICE_FAILURE));
    }
  };
};

/* Clear the order history details when the user leave the order details page */
export const clearOrderHistoryDetails = () => {
  return async dispatch => {
    dispatch({
      type: types.CLEAR_ORDER_HISTORY_DETAIL
    });
  };
};

/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string, showToast: boolean = false) => {
  return (dispatch) => {
    const { message, errorCode } = getErrorObject(error);

    /* Update the error response in the store */
    if (type !== "")
      dispatch({ type: type, payload: { error: message } });

    /* Show error message */
    if (showToast) {
      /* If error code is exist show the error code message or show the error message returned by the API request */
      if (errorCode !== "")
        dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
      else
        errorToast({ content: message });
    }
  }
};